import React from 'react';
import { IconButton } from 'material-ui';
import FontIcon from 'material-ui/FontIcon';
import moment from 'moment';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import firebase from '../firebase';



export default ({ data, onDuplicate }) => {

  const renderRow = (row, index) => (
    <TableRow key={`${row.notification.title}-${index}`}>
      <TableRowColumn>{row.notification.title}</TableRowColumn>
      <TableRowColumn>{row.notification.body}</TableRowColumn>
      <TableRowColumn>
        { 
          row.android &&  <FontIcon className="fab fa-android" />
        }
        {
          row.ios && <FontIcon className="fab fa-apple" />
        }
      </TableRowColumn>
      <TableRowColumn>{row.type === 'TOPIC' ? row.topic || 'All Devices' : 'All Devices'}</TableRowColumn>
      <TableRowColumn>{moment(row.createdAt.seconds * 1000).format('MMM DD, YYYY hh:mm a zz')}</TableRowColumn>
      {/* <TableRowColumn> */}
        {/* <IconButton onClick={() => onDuplicate(row)}><FontIcon className="fas fa-copy" color="#008ec2" hoverColor="#09b4f3" style={{ marginRight: 8 }} />  </IconButton>     */}
        {/* <IconButton><FontIcon className="fas fa-trash-alt"  color="tomato" hoverColor="tomato" /></IconButton> */}
      {/* </TableRowColumn> */}
    </TableRow>
  )

  return (
    <Table
      fixedHeader={true}
      selectable={false}
    >
      <TableHeader
       displaySelectAll={false}
       adjustForCheckbox={false}
      >
        <TableRow>
          <TableHeaderColumn>Title</TableHeaderColumn>
          <TableHeaderColumn>Message</TableHeaderColumn>
          <TableHeaderColumn>Platforms</TableHeaderColumn>
          <TableHeaderColumn>Audience</TableHeaderColumn>
          <TableHeaderColumn>Delivery</TableHeaderColumn>
          {/* <TableHeaderColumn></TableHeaderColumn> */}
        </TableRow>
      </TableHeader>
      <TableBody
        displayRowCheckbox={false}
      >
        {data.map(renderRow)}
      </TableBody>
    </Table>
  )
}


// WEBPACK FOOTER //
// ./src/components/PushesList.js